import { FC, useRef, useState } from 'react';
import { toast } from 'react-toastify';

import { ModalForm } from 'components/ModalForm';
import { useModal } from 'context/ModalProvider/useModal';
import { ValidationGroup } from 'devextreme-react';
import { isSuccess } from 'utils/responseStatus';

import { useCreateDriverPumpAdjustmentsMutation } from 'bus/driverPumpAdjustments/servisec';
import { DriverPumpAdjustmentsItem } from 'bus/driverPumpAdjustments/types';

import { DriverSalaryAdjustmentsForm } from '../../components';

type Props = {
  onRefresh: () => void;
  type: 'driver' | 'mixer' | 'employee' | 'pump';
};

const DRIVER_SALARY_ADJUSTMENTS_CREATE: DriverPumpAdjustmentsItem = {
  id: null,
  date: '',
  driverId: null,
  comment: '',
};

export const CreateDriverSalaryAdjustmentsModal: FC<Props> = ({ onRefresh, type }) => {
  const { hideModal } = useModal();
  const modalValidateRef = useRef<ValidationGroup>(null);

  const [form, setForm] = useState<DriverPumpAdjustmentsItem>(DRIVER_SALARY_ADJUSTMENTS_CREATE);
  const [createDriverSalaryAdjustments] = useCreateDriverPumpAdjustmentsMutation();

  const handleChange = (
    name: keyof DriverPumpAdjustmentsItem,
    value: DriverPumpAdjustmentsItem[keyof DriverPumpAdjustmentsItem],
  ) => {
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = () => {
    const isValid = modalValidateRef.current?.instance.validate().isValid;

    if (!isValid || !form) return;

    const { id, ...createData } = form;
    createDriverSalaryAdjustments(createData).then((data) => {
      if (isSuccess(data)) {
        onRefresh();
        hideModal();
        toast.success('Запись успешно создана', {
          position: 'bottom-right',
        });
      }
    });
  };

  return (
    <ModalForm
      onHidden={hideModal}
      title="Создание корректировки"
      visible
      isLoadingSubmit={false}
      width={500}
      height="auto"
      textConfirm="Создать"
      hideOnOutsideClick={false}
      onSubmit={handleSubmit}
      ref={modalValidateRef}
    >
      <DriverSalaryAdjustmentsForm form={form} onChange={handleChange} type={type} />
    </ModalForm>
  );
};
